// 自定义的表单组件建议放在该目录下。
// 该目录导出的组件会自动注册到Vue中，并且可以被代码生成的模块扫描到
import CostItemSelect from '@/components/CostItemSelect'
import CostItemSelectVxe from '@/components/CostItemSelect/vxe.vue'
import CustomerAllSelect from '@/components/CustomerAllSelect'
import CustomerSelect from '@/components/CustomerSelect'
import SupplierSelect from '@/components/SupplierSelect'
import OurSelect from '@/components/OurSelect'
import PortSelect from '@/components/PortSelect'
import ContractSelect from '@/components/ContractSelect'
import ShipSelect from '@/components/ShipSelect'
import CargoSelect from '@/components/CargoSelect'

export default {
  CostItemSelect,
  CostItemSelectVxe,
  CustomerAllSelect,
  CustomerSelect,
  SupplierSelect,
  OurSelect,
  PortSelect,
  ContractSelect,
  ShipSelect,
  CargoSelect,
}
